import CardWrapper from "@/components/ui/CardWrapper.vue";
import MainButton from "@/components/ui/MainButton.vue";
import SkeletonItem from "@/components/ui/SkeletonItem.vue";
export default [
    CardWrapper,
    MainButton,
    SkeletonItem
]